import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import IntlPhoneField from '../components/IntlPhoneField';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    // Handle form submission here
    alert(t('messageSentSuccess'));
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-superfeo-gray via-white to-superfeo-lightpink/30 py-8 relative overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23E0218A' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-superfeo-pink mb-4 tracking-wide">
            {t('contactUs')}
          </h1>
          <p className="text-lg text-superfeo-darkgray font-body max-w-2xl mx-auto">
            {t('contactDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 border border-superfeo-lightpink">
            <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-6 tracking-wide">
              {t('sendMessage')}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-body font-semibold text-gray-700 mb-2">
                  {t('fullName')}
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:border-superfeo-gold focus:outline-none font-body text-base"
                  placeholder={t('enterFullNamePlaceholder')}
                />
              </div>

              <div>
                <label className="block text-sm font-body font-semibold text-gray-700 mb-2">
                  {t('emailAddress')}
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:border-superfeo-gold focus:outline-none font-body text-base"
                  placeholder={t('enterEmailPlaceholder')}
                />
              </div>

              <div>
                <label className="block text-sm font-body font-semibold text-gray-700 mb-2">
                  {t('phoneNumber')}
                </label>
                <IntlPhoneField
                  value={formData.phone}
                  onChangeE164={(phone) =>
                    setFormData((prev) => ({ ...prev, phone }))
                  }
                  tanzaniaOnly={false}
                  inputClassName="w-full p-4 border-2 border-gray-200 rounded-lg focus:border-superfeo-gold focus:outline-none font-body text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-body font-semibold text-gray-700 mb-2">
                  {t('message')}
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:border-superfeo-gold focus:outline-none font-body resize-none text-base"
                  placeholder={t('enterMessagePlaceholder')}
                />
              </div>

              <button
                type="submit"
                className="w-full bg-superfeo-gold hover:bg-yellow-600 text-white font-body font-bold py-4 px-6 rounded-lg transition-colors duration-200"
              >
                {t('sendMessageBtn')}
              </button>
            </form>
          </div>

            {/* Contact Information */}
          <div className="space-y-8">
            {/* Office Info */}
            <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 border border-superfeo-lightpink">
              <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-6 tracking-wide">
                {t('getInTouch')}
              </h2>
              <div className="space-y-6">
                {/* Phone */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-superfeo-gold rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-gray-800 text-lg">{t('simu')}</h3>
                    <p className="text-gray-600 font-body">
                      <a href="tel:+255629202626" className="hover:text-superfeo-pink transition-colors duration-200">+255 629 202 626</a>
                    </p>
                    <p className="text-gray-600 font-body">
                      <a href="tel:+255763100064" className="hover:text-superfeo-pink transition-colors duration-200">+255 763 100 064</a>
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-superfeo-gold rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-gray-800 text-lg">{t('email')}</h3>
                    <p className="text-gray-600 font-body">info@superfeoexpress.co.tz</p>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-superfeo-pink rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-gray-800 text-lg">{t('ofisi')}</h3>
                    <p className="text-gray-600 font-body">{t('headOffice')} - {t('ubungoTerminal')} - {t('darEsSalaaam')}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Hours */}
            <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 border border-superfeo-lightpink">
              <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-6 tracking-wide">
                {t('wakatiWaHuduma')}
              </h2>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <svg className="w-6 h-6 text-superfeo-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <div>
                    <h3 className="font-heading font-bold text-gray-800">{t('tunapaikanaKilaSiku')}</h3>
                    <p className="text-gray-600 font-body">{t('timeRange')}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <svg className="w-6 h-6 text-superfeo-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  <div>
                    <h3 className="font-heading font-bold text-gray-800">{t('customerSupportDesc')}</h3>
                    <p className="text-gray-600 font-body">{t('available24_7')}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="bg-green-500 rounded-xl shadow-lg p-8 text-white text-center">
              <h3 className="text-2xl font-heading font-bold mb-4 tracking-wide">
                {t('quickSupport')}
              </h3>
              <p className="font-body mb-6">
                {t('needImmediateAssistance')}
              </p>
              <a
                href="https://wa.me/255629202626"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-white text-green-500 font-body font-bold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                {t('chatOnWhatsApp')}
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;